/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

import { isErrorMarkedAsHandled, markErrorAsHandled } from '@confluence/graphql-error-processor';

import type { useGetUserCountNumberOfUsersInvitedQuery as useGetUserCountNumberOfUsersInvitedQuery$data } from './__types__/useGetUserCountNumberOfUsersInvitedQuery';

export const useGetUserCount = () => {
	const { data, error, loading } = useQuery<useGetUserCountNumberOfUsersInvitedQuery$data>(
		gql`
			query useGetUserCountNumberOfUsersInvitedQuery {
				license {
					licenseConsumingUserCount
				}
			}
		`,
		{
			fetchPolicy: 'cache-and-network',
		},
	);

	if (error && !isErrorMarkedAsHandled(error)) {
		markErrorAsHandled(error);
	}

	return {
		error,
		loading,
		userCount: data?.license?.licenseConsumingUserCount,
	};
};
